export const getFirstLineFromHTML = (value: string): string => {
  const lines = value.trim().split(/\r?\n/)
  return lines.length > 1 ? `${lines[0]}...` : lines[0]
}

export const extractTextfromHTML = (value: string): string => {
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = value

  tempDiv.innerHTML = tempDiv.innerHTML.replace(/<br\s*\/?>/gi, '\n')
  let firstP = true
  tempDiv.innerHTML = tempDiv.innerHTML.replace(/<p>/gi, () => {
    if (!firstP) {
      return '\n'
    }
    firstP = false
    return ''
  })

  return tempDiv.textContent || ''
}
